import type { FC } from 'react'

import Markdown from 'markdown-to-jsx'

interface PostContentProps {
  content: string
}

export const PostContent: FC<PostContentProps> = props => {
  const { content } = props

  return <Markdown>{content}</Markdown>
}
